import React from 'react';
import PropTypes from 'prop-types';
import { useGoogleLogin, useGoogleOneTapLogin } from '@react-oauth/google';
import googleLogo from '../../Assets/images/svg/google.svg';
import { GOOGLE_LOGIN } from '../../Constants/strings';

export const SSOLoginButton = ({
  onSuccess,
  onError,
  disabled,
}) => {
  const googleSignIn = useGoogleLogin({
    onSuccess,
    onError,
    onNonOAuthError: onError,
    scope: 'openid profile email https://www.googleapis.com/auth/calendar https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile https://www.googleapis.com/auth/calendar.events https://www.googleapis.com/auth/admin.directory.resource.calendar.readonly',
  });

  // Auto-login trigger for active Gmail sessions
  useGoogleOneTapLogin({
    onSuccess: (credentialResponse) => {
      // Explicitly inject the Client ID from the environment variable
      credentialResponse.clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;
      console.log('Google One Tap login successful:', credentialResponse);
      onSuccess(credentialResponse);
    },
    onError: (error) => {
      console.error('Google One Tap login error:', error);
      onError(error);
    },

    auto_select: false,
  });

  const handleClick = () => {
    if (disabled) return;
    googleSignIn();
  };

  return (
    <button type="button" onClick={handleClick} id="sso-login" disabled={disabled}>
      <img className="google-logo" src={googleLogo} alt="Google Logo" />
      {GOOGLE_LOGIN}
    </button>
  );
};

SSOLoginButton.propTypes = {
  onSuccess: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

SSOLoginButton.defaultProps = {
  disabled: false,
};
